<template>
	<div class="show-more" :class="{'closed': closed}" @click="closed = !closed">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'ShowMore',

	data() {
		
		return {
			closed: true
		}
	}
}
</script>

<style lang="stylus" scoped>
.show-more
	position relative

	@media (max-width: unit(media-phone-max, px))		
		&:after
			content 'Mostra meno'

			width 100%
			display block

			margin-top 1em
			padding 1em
			box-sizing border-box

			background-image linear-gradient(to bottom, rgba(dark, 0.8), dark)
			color primary

			text-align center

			cursor pointer
		
		&.closed
			max-height 35vh

			overflow hidden

			&:after
				content 'Leggi altro ...'

				position absolute
				left 0
				bottom 0
				z-index 1
</style>